import { render, staticRenderFns } from "./channelOptions.vue?vue&type=template&id=274f0dee&"
import script from "./channelOptions.vue?vue&type=script&lang=js&"
export * from "./channelOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274f0dee')) {
      api.createRecord('274f0dee', component.options)
    } else {
      api.reload('274f0dee', component.options)
    }
    module.hot.accept("./channelOptions.vue?vue&type=template&id=274f0dee&", function () {
      api.rerender('274f0dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/channelOptions.vue"
export default component.exports